import styled from 'common/styled-components';

export const PaddedFormItem = styled.div`
  margin: 5px;
  min-width: 0;
`;

export const Fields = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
`;